export const legacyContractOffices=[{id:'1',name:'Mock 본점'},{id:'2',name:'Mock 2호점'}]
export const legacyContractContent='<p><strong>Mock 계약 동의 내용</strong></p><p>본 내용은 검수용 비식별 하드코딩 데이터입니다.</p>'
export const legacyContractChecklist='<p>Mock 동의 항목을 확인하고 동의합니다.</p>'
